module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Regular.f458b72db206f8e28a34e51ce6fc0d8c.ttf";